export default __webpack_public_path__ + "static/media/rnr-sports-table-12.de915b4a.webp";